module.exports = __webpack_public_path__ + "static/img/video-camera-add-outlined.c49f9c47.svg";